import type { SaveASAConfigResponseAction } from '../../../../main/actions/AppleSearchAdsActions';
import type { FbSaveConfigResponseAction } from '../../../../main/actions/FacebookActions';
import type {
  GetAdWordsUserInfoResponseAction,
  RevokeGoogleAuthResponseAction,
  SaveAdWordsOnboardingResponseAction,
} from '../../../../main/actions/GoogleActions';
import type { ChangeReadyForSaveAction } from './changeReadyForSave.action';
import type { CreateInternalAdPartnerResponseAction } from './createInternalAdPartner.action';
import type { DeleteConnectionAction } from './deleteConnection.action';
import type { DeleteInternalPartnerResponseAction } from './deleteInternalPartner.action';
import type { DisablePartnerResponseAction } from './disablePartner.action';
import type { GetAdAccountsStatusAction } from './getAdAccountsStatus.action';
import type { GetAdOntologyResponseAction } from './getAdOntology.action';
import type {
  GetAdPartnerConnectionsErrorAction,
  GetAdPartnerConnectionsRequestAction,
  GetAdPartnerConnectionsResponseAction,
} from './getAdPartnerConnections.action';
import type { GetAdPartnerForOrgResponseAction } from './getAdPartnerForOrg.action';
import type { GetAdPartnersResponseAction } from './getAdPartners.action';
import type {
  GetConnectionDataErrorAction,
  GetConnectionDataRequestAction,
  GetConnectionDataResponseAction,
} from './getConnectionData.action';
import type {
  GetCustomPartnersLimitErrorAction,
  GetCustomPartnersLimitRequestAction,
  GetCustomPartnersLimitResponseAction,
} from './getCustomPartnersLimit.action';
import type { LogAdPartnerSearchResponseAction } from './logAdPartnerSearch.action';
import type { ResetSettingsResponseAction } from './resetSettings.action';
import type { RollbackUnsavedChangesAction } from './rollbackUnsavedChanges.action';
import type { SaveAdPartnerResponseAction } from './saveAdPartner.action';
import type { SavePostbackResponseAction } from './savePostback.action';
import type { SelectPartnerAction } from './selectPartner.action';
import type { UpdateConfigAction } from './updateConfig.action';
import type { UpdateConnectionAction } from './updateConnection.action';

export * from './getAdPartners.action';
export * from './getAdPartnerForOrg.action';
export * from './getAdOntology.action';
export * from './saveAdPartner.action';
export * from './deleteInternalPartner.action';
export * from './disablePartner.action';
export * from './savePostback.action';
export * from './createInternalAdPartner.action';
export * from './resetSettings.action';
export * from './logAdPartnerSearch.action';
export * from './getCustomPartnersLimit.action';
export * from './rollbackUnsavedChanges.action';
export * from './changeReadyForSave.action';
export * from './updateConfig.action';
export * from './selectPartner.action';
export * from './getSANAdPartnerZeitStatus';
export * from './getConnectionData.action';
export * from './deleteConnection.action';
export * from './updateConnection.action';
export * from './getAdPartnerConnections.action';
export * from './getAdAccountsStatus.action';

export type AdPartnerAction =
  | GetAdWordsUserInfoResponseAction
  | SaveASAConfigResponseAction
  | SaveAdWordsOnboardingResponseAction
  | FbSaveConfigResponseAction
  | GetCustomPartnersLimitErrorAction
  | GetCustomPartnersLimitRequestAction
  | SelectPartnerAction
  | ChangeReadyForSaveAction
  | RollbackUnsavedChangesAction
  | UpdateConfigAction
  | GetCustomPartnersLimitResponseAction
  | ResetSettingsResponseAction
  | LogAdPartnerSearchResponseAction
  | CreateInternalAdPartnerResponseAction
  | SavePostbackResponseAction
  | DisablePartnerResponseAction
  | DeleteInternalPartnerResponseAction
  | GetAdPartnersResponseAction
  | GetAdPartnerForOrgResponseAction
  | GetAdOntologyResponseAction
  | SaveAdPartnerResponseAction
  | RevokeGoogleAuthResponseAction
  | DeleteConnectionAction
  | UpdateConnectionAction
  | GetConnectionDataRequestAction
  | GetConnectionDataResponseAction
  | GetConnectionDataErrorAction
  | GetAdPartnerConnectionsRequestAction
  | GetAdPartnerConnectionsResponseAction
  | GetAdPartnerConnectionsErrorAction
  | DeleteConnectionAction
  | GetAdAccountsStatusAction
  | GetAdPartnerConnectionsErrorAction;
